import React from "react";
import PageHeader from "../../shared/components/PageHeader";

// Page-header definition for the legacy v1 Pre-K Development Tracker. Only the
// title and the term selector move into the v2 header; the domain tabs, the
// grade table, and the post-grades action stay in the legacy body. v1 owns the
// term list and the `term` param the tracker keys off, and hands them across the
// bridge as data + an onTermChange callback. Like Social Development, the page
// has no default term - it shows a "select a term" prompt until one is picked -
// so the empty option stays a real, selectable value.
export default function PkTrackerHeader({
  terms = [],
  selectedTermId,
  onTermChange,
}) {
  return (
    <PageHeader
      title="Pre-K Development Tracker"
      termSelector={{
        terms,
        value: selectedTermId,
        onChange: onTermChange,
        allowEmpty: true,
        emptyLabel: "Select term",
      }}
    />
  );
}
